import { isWhitelabel } from '@digital-retail/store-manager';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { AdditionalInfoDrawer } from '../../../components/AdditionalInfoDrawer/AdditionalInfoDrawer';
import Availability from '../../../components/Availability/Availability';
import { AvailabilityLocation } from '../../../components/Availability/AvailabilityLocation/AvailabilityLocation';
import {
  getDeliveryOptionBorderClassName,
  getZoneName,
} from '../../../components/Availability/DeliveryOptions/DeliveryOptions.Helper';
import CMRCalculatorMobile from '../../../components/CMRCalculator/Mobile';
import ComboItemsMobile from '../../../components/ComboSection/ComboItemsMobile';
import ProductServices from '../../../components/ProductServices/ProductServices';
import Warranty from '../../../components/Warranty/Warranty';
import Button from '../../../components/ui/Button/Button';
import _ from '../../../utils/LodashImports';
import ReturnPolicy from '../../ReturnPolicy/ReturnPolicy';
import { GetSharedDetailsStyles } from './index.style';

const GetSharedDetails = ({
  sizes,
  colorVariants,
  regionCode,
  store,
  is1pSeller,
  isStoreAvailabilityVisibleInPDP,
  showCollectionButtonVisible,
  handleAddToCart,
  comboData,
  product,
  labels,
  showCMRCalculator,
  setServiceOption,
  setWarrantyOption,
  isWarrantyTooltipEnabled,
  additionalWarrantyLabel,
  layout,
  isSoCom = false,
  appCtx,
  sellerName,
  darSectionActive,
  warrantyOptions,
  serviceOptions,
  selectedZone,
  zoneConfig,
  setZoneConfig,
  isDefaultComuna,
}) => {
  const { isImprovedWarrantyUiEnabled = true, isImprovedServicesUiEnabled = true } = _.get(
    appCtx,
    'siteConfig.toggles',
    {}
  );

  const isWhitelabelSite = isWhitelabel({ store });

  const { comunaName } = getZoneName(selectedZone, isDefaultComuna) || { comunaName: '' };

  useEffect(() => {
    if (selectedZone && !isDefaultComuna) setZoneConfig({ ...selectedZone });
  }, [selectedZone]);

  return (
    <>
      {showCollectionButtonVisible && (
        <div className={`addToCart-container ${layout === 'hardline' ? 'collection' : ''} fa--add-cart__mobile`}>
          <Button type="outline" onClick={handleAddToCart} size="xtra-large">
            <span>
              {labels.SEE_COLLECTION_BUTTON_LABEL}
              <i className="csicon-arrow_down_small" />
            </span>
          </Button>
        </div>
      )}
      {isImprovedWarrantyUiEnabled && isImprovedServicesUiEnabled && (
        <>
          <Warranty
            warrantyOptions={warrantyOptions}
            setWarrantyOption={setWarrantyOption}
            startsFromLabel={labels.PDP_STARTS_FROM}
            tooltipToggle={isWarrantyTooltipEnabled}
            additionalWarrantyLabel={additionalWarrantyLabel}
            sellerName={sellerName}
          />
          <div className="services-divider" />
          <ProductServices serviceOptions={serviceOptions} setServiceOption={setServiceOption} />
        </>
      )}
      {!!product.showShippingModal && (
        <div className={cx('delivery-options-wrapper', getDeliveryOptionBorderClassName(isWhitelabelSite))}>
          {comunaName && (
            <div className="avl-content">
              <AvailabilityLocation comunaName={comunaName} />
            </div>
          )}
          <div className="dlv-opt-wrapper">
            <Availability
              sizes={sizes}
              colorVariants={colorVariants}
              regionCode={regionCode}
              store={store}
              isStoreAvailabilityVisibleInPDP={isStoreAvailabilityVisibleInPDP}
              is1pSeller={is1pSeller}
              selectedZone={selectedZone}
              zoneConfig={zoneConfig}
              setZoneConfig={setZoneConfig}
              isDefaultComuna={isDefaultComuna}
              comunaName={comunaName}
            />
          </div>
        </div>
      )}
      <div className="marginWrapper">
        {comboData && <ComboItemsMobile comboData={comboData} />}
        <AdditionalInfoDrawer description={product.longDescription} labels={labels} isSoCom={isSoCom} />
        {showCMRCalculator && (
          <div
            className={`cmrCalculator-container  ${
              layout === 'hardline' ? 'fa--cmr-calculator-hardline__mobile' : 'fa--cmr-calculator-softline__mobile'
            }`}
          >
            <CMRCalculatorMobile errorMessage={labels.CMR_INSTALLMENT_ERROR_MESSAGE} />
          </div>
        )}
        {layout === 'hardline' && (
          <>
            <ReturnPolicy returnPolicy={product.returnPolicy} darSectionActive={darSectionActive} />

            {!isImprovedServicesUiEnabled && !isImprovedWarrantyUiEnabled && (
              <>
                <ProductServices serviceOptions={serviceOptions} setServiceOption={setServiceOption} />
                <Warranty
                  warrantyOptions={warrantyOptions}
                  setWarrantyOption={setWarrantyOption}
                  startsFromLabel={labels.PDP_STARTS_FROM}
                  tooltipToggle={isWarrantyTooltipEnabled}
                  additionalWarrantyLabel={additionalWarrantyLabel}
                  sellerName={sellerName}
                />
              </>
            )}
          </>
        )}
      </div>
      <style jsx>{GetSharedDetailsStyles}</style>
    </>
  );
};

GetSharedDetails.defaultProps = {
  setServiceOption: () => {},
  setWarrantyOption: () => {},
  isWarrantyTooltipEnabled: false,
  additionalWarrantyLabel: false,
  isSoCom: false,
  selectedZone: {},
  zoneConfig: {
    region: {},
    comuna: {},
  },
  isDefaultComuna: false,
};

GetSharedDetails.propTypes = {
  sizes: PropTypes.array.isRequired,
  colorVariants: PropTypes.array.isRequired,
  regionCode: PropTypes.string.isRequired,
  store: PropTypes.string.isRequired,
  is1pSeller: PropTypes.bool.isRequired,
  isStoreAvailabilityVisibleInPDP: PropTypes.bool.isRequired,
  handleAddToCart: PropTypes.func.isRequired,
  comboData: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  showCMRCalculator: PropTypes.bool.isRequired,
  setServiceOption: PropTypes.func,
  setWarrantyOption: PropTypes.func,
  isWarrantyTooltipEnabled: PropTypes.bool,
  additionalWarrantyLabel: PropTypes.bool,
  layout: PropTypes.string.isRequired,
  isSoCom: PropTypes.bool,
  appCtx: PropTypes.object.isRequired,
  sellerName: PropTypes.string.isRequired,
  darSectionActive: PropTypes.bool.isRequired,
  warrantyOptions: PropTypes.array.isRequired,
  serviceOptions: PropTypes.array.isRequired,
  selectedZone: PropTypes.object,
  zoneConfig: PropTypes.object,
  setZoneConfig: PropTypes.func.isRequired,
  isDefaultComuna: PropTypes.bool,
  showCollectionButtonVisible: PropTypes.bool.isRequired,
};

export { GetSharedDetails };
